import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Response } from "../shared/models/Response";
import { environment } from "src/environments/environment";

export interface UxFeedbackState {
	value: number;
	label: string;
}

export interface UxFeedbackEligibilityDto {
	eligible: boolean;
	nextAllowedAt?: string;
	cooldownHours: number;
	promptVersion: number;
	states: UxFeedbackState[];
}

export interface UxFeedbackEventDto {
	promptKey: string;
	contextKey: string;
	eventType: string;
	clientSessionId: string;
	userSessionId?: string;
	emisorId?: string;
	pageRoute?: string;
	appVersion?: string;
	userAgent?: string;
	metadataJson?: string;
	occurredAt?: string;
	timeSinceShownMs?: number;
}

export interface HappinessResponseCreateDto {
	promptKey: string;
	contextKey: string;
	clientSessionId: string;
	userSessionId?: string;
	emisorId?: string;
	score: number;
	scoreBucket: number;
	stateLabel: string;
	questionVersion: number;
	timeToSubmitMs?: number;
	clientMetadataJson?: string;
}

export interface FollowupAnswerDto {
	orderNo: number;
	questionKey: string;
	questionText: string;
	questionType: string;
	optionKey?: string;
	optionText?: string;
	answerText?: string;
	answerNumber?: number;
}

export interface FollowupDto {
	bucket: string;
	answers: FollowupAnswerDto[];
}

@Injectable({
	providedIn: "root",
})
export class UxFeedbackService {
	private readonly REST_API_SERVER = environment.backend_server + "/UxFeedback";

	constructor(private http: HttpClient) {}

	getEligibility(contextKey: string, pageRoute: string, promptKey: string = "happiness_support"): Observable<Response<UxFeedbackEligibilityDto>> {
		const params = new HttpParams().set("promptKey", promptKey).set("contextKey", contextKey).set("pageRoute", pageRoute || "/");
		return this.http.get<Response<UxFeedbackEligibilityDto>>(this.REST_API_SERVER + "/eligibility", { params });
	}

	postEvent(dto: UxFeedbackEventDto): Observable<Response<boolean>> {
		return this.http.post<Response<boolean>>(this.REST_API_SERVER + "/event", dto);
	}

	postHappinessResponse(dto: HappinessResponseCreateDto): Observable<Response<string>> {
		return this.http.post<Response<string>>(this.REST_API_SERVER + "/happiness/response", dto);
	}

	postFollowupAnswers(responseId: string, dto: FollowupDto): Observable<Response<boolean>> {
		return this.http.post<Response<boolean>>(this.REST_API_SERVER + "/happiness/" + responseId + "/followup", dto);
	}
}
